import React from 'react';
import DataTable, {IDataTableProps} from "./DataTable";
import DataList, {IDataListProps} from "./DataList";
import DataCardList from "./DataCardList";
import useIsMobile from "../../../hooks/useIsMobile";

interface IDataGridTableProps<T> extends IDataTableProps<T> {
    responsive?: any | boolean;
    mobileFilterByColumn?: boolean;
}

interface IDataGridListProps<T> extends IDataListProps<T> {
    responsive?: any | boolean;
    mobileFilterByColumn?: boolean;
}

export default function DataGrid<T>(props: IDataGridTableProps<T> | IDataGridListProps<T>): JSX.Element {
    const {
        responsive = false,
        mobileFilterByColumn,
        ...rest
    } = props;

    return responsive === 'card' && useIsMobile()
        ? <DataCardList {...rest} mobileFilterByColumn={mobileFilterByColumn} />
        : responsive === true && useIsMobile()
            ? <DataList {...rest} />
        : <DataTable {...rest} />;
}
